import initConnection from '@/plugins/drone-auth'
import Vue from 'vue'
export default {
  namespaced: true,

  state: {
    currentToken: {},
    currentPath: {},
    loggedIn: false,
    DroneApp: null,
    accountId: null,
    lang: "en",
    isPublicToken: false
  },

  getters: {
    lang: state => state.lang,
    loggedIn: state => state.loggedIn,
    accountId: state => state.accountId,
    currentToken: state => state.currentToken,
    currentPath: state => state.currentPath
  },

  mutations: {
    setLang(state, value){
      state.lang = value
    },
    
    setCurrentPath(state, value) {
      state.currentPath = value
    },

    setCurrentToken(state, token){
      state.currentToken = token;
    },

    setLoginStatus(state, status){
      state.loggedIn = status
    },

    setDroneApp(state, obj){
      state.DroneApp = obj
    },

    setAccountId(state, accountId){
      state.accountId = accountId
    }
  },

  actions: {
    refresh: async function(context){
      if(this.getters['app/isPublicToken']){
        return
      }
      
      const droneApp = initConnection({
        client_id: 'RhdTHb-dodSoKmNJbj-VlvSR4NBAAxEVLm1KLGFxESs',
        account_id: context.getters.accountId
      })
      context.commit("setDroneApp", droneApp)

      await droneApp.authenticatedToken().then(response => {
        context.commit("setCurrentToken", response.result.token)
        context.commit("setLoginStatus", true)
      })
      .catch((err) => {
        Vue.debug(err)
        context.commit("setCurrentToken", null)
        context.commit("setLoginStatus", false)
      })
    },
  }
}

